<template>
  <div
    class="relative lg:sticky"
    :class="isProfileCard && isQueueCard ? 'top-16' : 'top-24'"
  >
    <div
      v-if="configDashboard"
      class="flex items-center justify-between absolute z-10 p-6 w-full"
    >
      <h4>Quest Card</h4>
      <vs-chip
        transparent
        color="#FBA727"
        class="text-base text-center cursor-pointer"
        @click.native="removeQuestCard"
      >
        Remove
      </vs-chip>
    </div>
    <vx-card
      class="overflow-hidden"
      v-if="coachUserData && coachUserData.userType === 'trainee'"
    >
      <vs-row
        class="p-6 pb-0 flex justify-between items-center"
        :class="configDashboard ? 'opacity' : ''"
      >
        <h3 class="mb-1">{{ $t('orgDashboard.userDashboard.activeQuest') }}</h3>
        <!-- <vs-icon
          @click="editActiveQuestCard = true"
          class="text-2xl icon-bg p-3 rounded-full cursor-pointer"
          color="#FBA727"
          icon="icon-edit-2"
          icon-pack="feather"
      /> -->
      </vs-row>
      <hr class="my-4" style="clear: both; border-top: #f4f6fb" />
      <vs-row :class="configDashboard ? 'opacity' : ''">
        <vs-col v-if="compentencyData">
          <div class="w-full flex flex-col items-center justify-center">
            <vs-avatar class="mb-4" size="60px" :src="compentencyData.icon" />
            <h4>{{ compentencyData.comp }}</h4>
          </div>
        </vs-col>
        <vs-col v-else>{{ $t('orgDashboard.userDashboard.noDevelopmentPlans') }}</vs-col>
        <vs-col class="p-6">
          <vs-row class="flex">
            <vs-col
              class="flex flex-col align-items-center justify-center"
              vs-lg="4"
              vs-sm="4"
              vs-xs="12"
            >
              <div class="flex align-items-center justify-center">
                <vue-circle
                  :progress="
                    coachUserData &&
                    coachUserData.data &&
                    coachUserData.data.graphData &&
                    coachUserData.data.graphData.relevancy
                      ? coachUserData.data.graphData.relevancy
                      : 0
                  "
                  :size="80"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="0"
                  insert-mode="append"
                  :thickness="10"
                  :show-percent="true"
                >
                </vue-circle>
              </div>

              <h5 class="text-center">Relevancy</h5>
            </vs-col>
            <vs-col
              class="flex flex-col align-items-center justify-center"
              vs-lg="4"
              vs-sm="4"
              vs-xs="12"
            >
              <div class="flex align-items-center justify-center">
                <vue-circle
                  :progress="
                    coachUserData &&
                    coachUserData.data &&
                    coachUserData.data.graphData &&
                    coachUserData.data.graphData.progress
                      ? coachUserData.data.graphData.progress
                      : 0
                  "
                  :size="80"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="0"
                  insert-mode="append"
                  :thickness="10"
                  :show-percent="true"
                >
                </vue-circle>
              </div>

              <h5 class="text-center">Progress</h5>
            </vs-col>
            <vs-col
              class="flex flex-col align-items-center justify-center"
              vs-lg="4"
              vs-sm="4"
              vs-xs="12"
            >
              <div class="flex align-items-center justify-center">
                <vue-circle
                  :progress="
                    coachUserData &&
                    coachUserData.data &&
                    coachUserData.data.graphData &&
                    coachUserData.data.graphData.practice
                      ? coachUserData.data.graphData.practice
                      : 0
                  "
                  :size="80"
                  :reverse="false"
                  line-cap="round"
                  :fill="fill"
                  empty-fill="rgba(0, 0, 0, .1)"
                  :animation-start-value="0.0"
                  :start-angle="0"
                  insert-mode="append"
                  :thickness="10"
                  :show-percent="true"
                >
                </vue-circle>
              </div>

              <h5 class="text-center">Practice</h5>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row class="text-center" :class="configDashboard ? 'opacity' : ''"
        ><h4
          @click="toCoach"
          class="w-full skills-btn px-2 py-3 cursor-pointer"
        >
          Skills Details
        </h4></vs-row
      >
    </vx-card>

    <vx-card v-else class="p-3 md:p-6 overflow-hidden">
      <vs-row
        class="flex justify-between items-center"
        :class="configDashboard ? 'opacity' : ''"
      >
        <h3 class="mb-1">{{ $t('orgDashboard.userDashboard.activeQuest') }}</h3>
      </vs-row>
      <hr class="my-2" style="clear: both; border-top: #f4f6fb" />
      <vs-row
        v-if="
          coachUserData &&
          coachUserData.data &&
          Array.isArray(coachUserData.data)
        "
        :class="configDashboard ? 'opacity' : ''"
      >
        <vs-table ref="table" v-model="selected" :data="coachUserData.data">
          <template slot="thead">
            <vs-th sort-key="id">{{ $t("coach.tblHeadings.th2") }}</vs-th>
            <vs-th class="flex justify-center" sort-key="name">{{
              $t("coach.tblHeadings.th8")
            }}</vs-th>
            <vs-th sort-key="journey">{{ $t("coach.tblHeadings.th21") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody v-if="data">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in coachUserData.data"
              >
                <vs-td>
                  <p class="product-name font-medium truncate">
                    {{ tr.userData[0].firstName }}
                  </p>
                </vs-td>
                <vs-td class="flex justify-center">
                  <feather-icon
                    v-if="tr.motivationSurvey === 1"
                    icon="CircleIcon"
                    :title="$t('coach.playerJourney.t3_1')"
                    :svgClasses="['fill-current h-4 w-4', 'text-primary']"
                  />
                  <feather-icon
                    v-else-if="tr.motivationSurvey === 2"
                    icon="CircleIcon"
                    :title="$t('coach.playerJourney.t3_2')"
                    :svgClasses="['fill-current nt h-4 w-4', 'text-warning']"
                  />
                  <feather-icon
                    v-else
                    icon="CircleIcon"
                    :title="$t('coach.playerJourney.t3_3')"
                    :svgClasses="['fill-current h-4 w-4', 'text-grey']"
                  />
                  <feather-icon
                    v-if="tr.coachingSurvey === 1"
                    class="ml-2"
                    icon="CircleIcon"
                    :title="$t('coach.playerJourney.t4_1')"
                    :svgClasses="['fill-current h-4 w-4', 'text-primary']"
                  />
                  <feather-icon
                    v-else-if="tr.coachingSurvey === 2"
                    class="ml-2"
                    icon="CircleIcon"
                    :title="$t('coach.playerJourney.t4_2')"
                    :svgClasses="['fill-current h-4 w-4', 'text-warning']"
                  />
                  <feather-icon
                    v-else
                    class="ml-2"
                    icon="CircleIcon"
                    :title="$t('coach.playerJourney.t4_3')"
                    :svgClasses="['fill-current h-4 w-4', 'text-grey']"
                  />
                </vs-td>

                <vs-td>
                  <vs-tooltip
                    text="Development"
                    position="bottom"
                    class="flex justify-center"
                  >
                    <feather-icon
                      @click="toCoach"
                      class="p-1 rounded-md add-btn cursor-pointer text-center w-8 h-8"
                      icon="ArrowRightIcon"
                    />
                  </vs-tooltip>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vs-row>

      <vs-row v-else>
        <vs-col class="flex items-center">
          <img
            class="lg:w-24 w-64"
            src="@/assets/images/temp-img/empty-quest.svg"
          />
          <h5 class="ml-4 md:ml-2 text-sm text-left">{{ $t('orgDashboard.userDashboard.noDevelopmentPlans') }}</h5>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import constants from "@/constants";
import VueCircle from "vue2-circle-progress";

export default {
  components: {
    VueCircle,
  },
  data() {
    return {
      editActiveQuestCard: false,
      constants,
      fill: { gradient: ["#4D927F", "#B7DA64"] },
      coachUserData: {},
      CCD: this.$t("coach.addNewSkill.data"),
      compentencyData: {},
      itemsPerPage: 5,
      selected: [],
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    userWidgets() {
      return this.$store.state.dashboard.userWidgets;
    },
    configDashboard() {
      return this.$store.state.dashboard.configDashboard;
    },
    locale() {
      return this.$i18n.locale;
    },
    isProfileCard() {
      return this.$store.state.dashboard.isProfileCard;
    },
    isQueueCard() {
      return this.$store.state.dashboard.isQueueCard;
    },
  },
  methods: {
    removeQuestCard() {
      const questCard = this.userWidgets.find(
        (item) => item.widgetId === "ACTIVITY_QUEUE"
      );
      this.$store
        .dispatch("dashboard/removeWidget", questCard)
        .then((res) => {
          for (var i = 0; i < this.userWidgets.length; i++) {
            if (this.userWidgets[i].widgetId === "ACTIVITY_QUEUE") {
              this.$store.commit("dashboard/REMOVE_WIDGET", i);
            }
          }
          this.$store.commit("dashboard/SHOW_QUEST_CARD", false);
        })
        .catch((err) => {
          throw err;
        });
    },
    getCoachUserData() {
      this.$store
        .dispatch("coach/getCoachUserData", this.userData._id)
        .then((res) => {
          if (res && res.userType === "trainee") {
            this.coachUserData = res;
            const characteristicId =
              res && res.data && res.data.competencyId
                ? res.data.competencyId.split("-")[0]
                : "";
            const competencyId =
              res && res.data && res.data.competencyId
                ? res.data.competencyId.split("-")[1]
                : "";
            const competencies = this.CCD[characteristicId].competencies;
            this.compentencyData = competencies[competencyId];
          } else {
            this.coachUserData = res;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    toCoach() {
      let user = this.userData.email.slice(0, this.userData.email.indexOf("@"));
      window.location.href = `https://api.coach.getboarded.com/oauth/?selectedAccount=${user}`;
    },
  },
  mounted() {
    this.getCoachUserData();
  },
};
</script>

<style lang="scss" scoped>
$bg: #fba62742;
$color: #fba727;
.icon-bg {
  background-color: $bg;
}
.skills-btn {
  color: $color !important;
  background: $bg;
}

.vx-card ::v-deep .vx-card__body {
  padding: 0;
}
.opacity {
  opacity: 0.075;
}

.circle ::v-deep .percent-text {
  font-size: 15px !important;
}

.stick-top {
  top: 6em;
}

.vs-con-table ::v-deep .vs-table--tbody-table {
  min-width: 100%;
}

.vs-con-table {
  width: 100%;
}

.add-btn {
  color: #fff;
  background: $color;
  border-radius: 5em;
}

@media screen and (max-width: 991px) {
  .vs-con-table ::v-deep .vs-table--content {
    width: 100%;
  }
}
</style>
